import React from 'react';

import Goal from 'containers/Goals/Goal';

const UserGoalsLoading = () => {

  return (
    <div className="Goals">
      <table>
        <tbody>
          <Goal key="loader1" isEmpty />
          <Goal key="loader2" isEmpty />
          <Goal key="loader3" isEmpty />
        </tbody>
      </table>
    </div>
  );
};


export default UserGoalsLoading;





/** WEBPACK FOOTER **
 ** ./src/members/Main/UserGoals/UserGoalsLoading/index.js
 **/